import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.solidIcon.background.default.dark(params);

export default dark;
